var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('t-form-select',{staticClass:"jgile-month-picker",class:{ 'has-selection': _vm.month !== null },attrs:{"id":_vm.id,"name":_vm.name,"options":_vm.options,"value":_vm.month},on:{"change":_vm.updateValue}})}
var staticRenderFns = []

export { render, staticRenderFns }